"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listEncryptedKeyMetadata = void 0;
const service_client_1 = require("../service-client");
const utils_1 = require("../utils");
/** Get list of metadata for previously encrypted and persisted private keys
 * Note that this method does include the `ciphertext` or `dataToEncryptHash` values necessary to decrypt the keys.
 * To get those values, call `getEncryptedKey()` with the `id` for the appropriate key returned by this method.
 *
 * @param { ListEncryptedKeyMetadataParams } params Parameters required to fetch the encrypted private key metadata
 * @returns { Promise<StoredKeyMetadata> } The encrypted private key and its associated metadata
 */
async function listEncryptedKeyMetadata(params) {
    const { pkpSessionSigs, litNodeClient } = params;
    return (0, service_client_1.listPrivateKeyMetadata)({
        sessionSig: (0, utils_1.getFirstSessionSig)(pkpSessionSigs),
        litNetwork: litNodeClient.config.litNetwork,
    });
}
exports.listEncryptedKeyMetadata = listEncryptedKeyMetadata;
//# sourceMappingURL=list-encrypted-key-metadata.js.map